module.exports = __webpack_public_path__ + "static/media/anli3.3667358.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anli3.mp4
// module id = dUa2
// module chunks = 1